export default {
      id: "ic_slider_next-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_slider_next-usage",
      toString: function () {
        return this.url;
      }
    }